import { useEffect, useRef, useState } from 'react';
import { Alert } from 'react-bootstrap';
import { useToastStore, Toast } from '@store/toast.store';
import './ToastContainer.scss';

const ToastItem = ({ toast }: { toast: Toast }) => {
    const removeToast = useToastStore((s) => s.removeToast);
    const [exiting, setExiting] = useState(false);
    const timerRef = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => {
        timerRef.current = setTimeout(() => {
            setExiting(true);
            setTimeout(() => removeToast(toast.id), 200);
        }, toast.duration);

        return () => clearTimeout(timerRef.current);
    }, [toast.id, toast.duration, removeToast]);

    const handleClose = () => {
        clearTimeout(timerRef.current);
        setExiting(true);
        setTimeout(() => removeToast(toast.id), 200);
    };

    return (
        <Alert
            variant={toast.variant}
            dismissible
            onClose={handleClose}
            className={`toast-item${exiting ? ' toast-item--exiting' : ''}`}
        >
            {toast.message}
        </Alert>
    );
};

const ToastContainer = () => {
    const toasts = useToastStore((s) => s.toasts);

    if (toasts.length === 0) return null;

    return (
        <div className="toast-container">
            {toasts.map((toast) => (
                <ToastItem key={toast.id} toast={toast} />
            ))}
        </div>
    );
};

export default ToastContainer;
